import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';

export const customerGroup = 'eintracht_frankfurt';
const supportEmail = {
	[customerGroup]: 'info@smoothr.de',
};
const firebaseConfig = {
	[customerGroup]: {
		apiKey: 'AIzaSyAU9gvAA0Nfpf8OPamdH2SY2flBydAD_GY',
		authDomain: 'eintracht-app.firebaseapp.com',
		projectId: 'eintracht-app',
		storageBucket: 'eintracht-app.firebasestorage.app',
		messagingSenderId: '327027437479',
		appId: '1:327027437479:web:ff2bcfb751fa7deacdd082',
	},
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyDAdrZ5vG1_A-5rChcnhh6UQjfhX1OI9QE',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup,
	...apiEnvironment,
	countryList: ['en'],
	gaId: '',
	hasRecommendations: true,
	location: '',
	deactivateDelivery: false,
	enableCashPayment: true,
	allowNavigationToWorldline: false,
	urlQrCode: 'smoothr://',
	defVenue: '68d50e0d4ba6b4404c72b8e1',
};
